

import { EventBus, TEMED_WIDGET_EVENTS } from './EventBus';
import * as GMUtils from '../utils/GMUtils';
import * as GeoUtils from '../utils/GeoUtils';
import { } from '@types/googlemaps';
import { ILocation } from '../models';
import * as DataService from './DataService'

declare var google: any;

export interface InternalStateType {
  [key: string]: any;
}


export class AppService{

  private static _instance: AppService;

  private geoRequest: Promise<any> = null;

  public _state: InternalStateType = { };

  public static getInstance()
  {
      return this._instance || (this._instance = new this());
  }

  /**
   * Already return a clone of the current state.
   */
  public get state() {
    return this._state = this._clone(this._state);
  }
  /**
   * Never allow mutation
   */
  public set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }

  constructor(){
    this.requestLocation();
  }

  public get(prop?: any) {
    /**
     * Use our state getter for the clone.
     */
    const state = this.state;
    if(prop){
      return state.hasOwnProperty(prop) ? state[prop] : null;
    }else{
      return state;
    }
  }

  public set(prop: string, value: any) {
    /**
     * Internally mutate our state.
     */
    return this._state[prop] = value;
  }

  public requestLocation(){
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: Position) => {
        const coords = { accuracy: position.coords.accuracy, latitude: position.coords.latitude, longitude: position.coords.longitude };
        this.set('userPosition', coords);
        this.getUserLocation(true).then( location => {
          EventBus.$emit(TEMED_WIDGET_EVENTS.GEO_LOCATION_CHANGED, location);
        });
      },
      (e) => {
        this.set('userPosition', null);
        console.log(e.message);
      });
    }else{
      this.set('userPosition', null);
      console.log("geolocation is not available");
    }
  }

  public getUserLocation(force = false): Promise<ILocation> {
    return new Promise<ILocation>((resolve, reject) => {
      const state = this.state;

      if(state.userLocation && !force){
        resolve(state.userLocation);
      }else if(state.userPosition){
        const userPosition = state.userPosition;
        if(!this.geoRequest){
          // this.geoRequest = GMUtils.geocodePosition(40.8040451, -74.1802146);
          this.geoRequest = GMUtils.geocodePosition(userPosition.latitude, userPosition.longitude);
        }


        this.geoRequest.then(response => {
              if(response.json.status === "OK"){

                if(response.json.results[0]){
                  const userLocation: ILocation = {
                    latitude: userPosition.latitude,
                    longitude: userPosition.longitude,
                    state: DataService.DEFAULT_STATE,
                    country: '',
                    city: '',
                    zip: ''
                  }
                  const results = response.json.results;

                  for (const addressComp of results[0].address_components){
                    const shortName = addressComp.short_name;
                    if(addressComp.types[0] === 'country'){
                      userLocation.country = shortName
                    }
                    if(addressComp.types[0] === 'locality'){
                      userLocation.city = shortName
                    }
                    if(addressComp.types[0] === 'postal_code'){
                      userLocation.zip = shortName
                    }
                    if(addressComp.types[0] === 'administrative_area_level_1' && Object.keys(DataService.STATES).indexOf(shortName) !== -1){
                      userLocation.state = shortName
                    }

                  }
                  this.set('userLocation', userLocation);
                  // this.geoRequest = null;
                  resolve(userLocation);
                }
              }
          })
          .catch(e => {
            reject(e);
          });
      }else{
        resolve(null);
      }
    });

  }

  private _clone(object: InternalStateType) {
    /**
     * Simple object clone.
     */
    return JSON.parse(JSON.stringify( object ));
  }

}

